import { invoke } from '@shared/easyfy.decorators';
import Splide from '@splidejs/splide';
import { defaultTranslations } from '@webModules/splideHelper';

namespace Meds.Components {
  @invoke
  class ImageSliderComponent {
    static Instance: ImageSliderComponent;

    constructor() {
      ImageSliderComponent.Instance = this;
    }

    onInit() {
      ImageSliderComponent.refreshProductList();

      window.addEventListener('ImageSliderComponent', ((event: CustomEvent) => {
        ImageSliderComponent.refreshProductList(0);
      }) as EventListener);
    }

    static refreshProductList = (timeout: number = 0) => {
      setTimeout(() => {
        document
          .querySelectorAll('[data-container="image-slider-scroll"]')
          .forEach((list) => {
            list.classList.add('splide');
            let perView: number = parseInt(list.attributes['data-perview']?.value, 10);
            if (!perView) {
              perView = 5;
            }

            new Splide(list as HTMLElement, {
              type: 'loop',
              perPage: perView,
              speed: 500,
              dragMinThreshold: 20,
              flickMaxPages: 1,
              flickPower: 100,
              snap: false,
              arrows: false,
              pagination: false,
              breakpoints: {
                1100: {
                  perPage: 2
                },
                768: {
                  perPage: 2,
                  padding: {
                    left: 0,
                    right: list.clientWidth * 0.22
                  }
                }
              },
              i18n: defaultTranslations
            }).mount();
          });
      }, timeout);
    };
  }
}
